import httpClient from "../../../shared/api/httpClient";

export const dashboardApi = {
  // filtros: { anoPagamento, mesPagamento, dataInicio, dataFim } — todos opcionais; nenhum
  // deles significa "todos os períodos" (sem recorte). O mês é o mês em que o pagamento cai
  // (issue #18). dataInicio/dataFim (período personalizado, "yyyy-MM-dd") têm prioridade
  // sobre o mês no backend, igual a plantoesApi.list — o chamador nunca deveria enviar os
  // dois ao mesmo tempo.
  overview: ({ anoPagamento, mesPagamento, dataInicio, dataFim } = {}) => {
    const params = new URLSearchParams();
    if (dataInicio && dataFim) {
      params.set("data_inicio", dataInicio);
      params.set("data_fim", dataFim);
    } else {
      if (anoPagamento) params.set("ano_pagamento", anoPagamento);
      if (mesPagamento) params.set("mes_pagamento", mesPagamento);
    }
    const qs = params.toString();
    return httpClient.get(`/api/v1/dashboard/overview${qs ? `?${qs}` : ""}`).then((r) => r.data.dados);
  },
  kpis: () => httpClient.get("/api/v1/dashboard/kpis").then((r) => r.data.dados),
};
